module.exports = __webpack_public_path__ + "img/ic_zofi.33574360.svg";